import { SizableText, styled } from '@mythical/ui'
import { IconExternalLink } from 'app/components/primitive/Icon'
import React from 'react'
import { ButtonLink } from '../primitive/Button'
import { Container } from '../structure/Container'
import Section from '../structure/Section'
import { CallToAction as CallToActionBlock } from 'app/blocks/call-to-action'
import { useStores } from 'app/store'

const CtaHeading = styled(SizableText, {
  name: 'CtaHeading',
  tag: 'h2',
  ff: '$heading',
  color: '$brandPurple',
  fow: '500',
  tt: 'uppercase',
  ta: 'center',
  variants: {
    displaySize: {
      md: {
        size: '$6',
        $gtSm: {
          size: '$8',
          fow: '500',
        },
      },
      lg: {
        size: '$8',
        $gtSm: {
          size: '$9',
          fow: '500',
        },
      },
    },
  } as const,
  defaultVariants: {
    displaySize: 'md',
  },
})

const buttonSizeMap = {
  md: '$3',
  lg: '$4',
} as const

interface CallToActionProps {
  block: CallToActionBlock
  slug?: string
}

export const CallToAction = ({ block, slug }: CallToActionProps) => {
  const { userStore } = useStores()
  const { ctaTitle, ctaHref, ctaLabel, displaySize = 'md', excludedTiers } = block

  if (excludedTiers?.length && excludedTiers?.some(tier => tier.name === userStore?.user?.tier)) {
    return null
  }

  if (slug === 'merch') {
    return (
      <Container variant="mediumLarge">
        <Section paddedX py="$0">
          <ButtonLink
            size="$5"
            href={ctaHref}
            w="100%"
            mx={0}
            borderWidth={0}
            borderRadius="$5"
            bg="$bgTertiary"
            color="$fgPrimary"
            iconAfter={<IconExternalLink size={20} color="$fgSecondary" />}
            textProps={{
              color: '$fgPrimary',
              size: '$6',
              fontWeight: '600',
            }}
            justifyContent="space-between"
            px="$4"
          >
            {ctaLabel || 'Go to Merch Store'}
          </ButtonLink>
        </Section>
      </Container>
    )
  }

  return (
    <Section
      gap="$3.5"
      paddedX
      ai="center"
      jc="center"
      maxWidth={800}
      mx="auto"
      $gtXs={{ gap: '$3.5' }}
    >
      {ctaTitle && <CtaHeading displaySize={displaySize}>{ctaTitle}</CtaHeading>}
      <ButtonLink size={buttonSizeMap[displaySize]} href={ctaHref} mx="auto">
        {ctaLabel}
      </ButtonLink>
    </Section>
  )
}
